export default {
  props: {
    videoId: {
      type: String,
      required: true,
    },
    videoSrc: {
      type: String,
      required: true,
    },
    posterSrc: {
      type: String,
      default: '',
    },
    sourceType: {
      type: String,
      default: 'video/mp4',
    },
  },

  mounted() {
    this.initVideo();
  },

  methods: {
    initVideo() {
      const video = document.querySelector(`#${this.videoId}`);
      if (video) {
        new Toolkit.BackgroundVideo(video);
      }
    },
  },
};
